import type { FaireProductEntity } from "../../entity_types/product";

export const p_2wdyzrav1i: FaireProductEntity = {
  token: "p_2wdyzrav1i",
  type: "product",
  name: "Just The Way Lg Charm Bowl (Boxed)",
  brandToken: "b_4ff718f6",
  brandName: "Basic Spirit",
  imageUrl:
    "https://cdn.faire.com/fastly/1624e18b98142e745645230bb1fea71f9708e1a6f53d2572370db858c0c532f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c25778dbe8f44effa7f72348a0669543d82d1f146a29164cc4955418bd22b122.webp",
  ],
  priceDollars: 11.64,
  description:
    'The "I Love You Just the Way You Are" dish is a beautifully crafted pewter charm bowl, perfect for expressing affection and appreciation. This elegant piece is designed to hold small treasures or serve as a decorative accent in any space. It comes beautifully boxed, making it an ideal gift for loved ones on special occasions or as a heartfelt gesture.\nApprox piece 2.25" in diameter.\nComes in a gift box w/ pewter decorative piece Approx 3" x 3" x .75".\nHandmade By The Sea!\n10% Of profits fund charitable organizations. ',
  tags: [],
  msrpDollars: 23.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:34.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
